import RadioButton from '../../../../../components/RadioButton';
import { CodeBlock, dracula } from 'react-code-blocks';
import Button from '../../../../../components/Button';
import { Dispatch, MouseEvent, SetStateAction } from 'react';
import styles from './style.module.scss';
import { questionHelp } from '../../../../../config/exam';
import { HelpIcon } from '../../../../../assets/icons/common';
import { useProctoring } from '../../../../../hooks/useProctoring';

interface Props {
    counter: number;
    question: string;
    next: () => void;
    showHelp: boolean;
    jobTitle?: string;
    enableNext: boolean;
    userId: string | null;
    totalQuestions: number;
    selectedOption: number;
    currentQuestion: number;
    isLastQuestion: boolean;
    examId: string | undefined;
    questionOptions: string[];
    onSelectFromHelp: () => void;
    isFetchingQuestions: boolean;
    setShowHelp: Dispatch<SetStateAction<boolean>>;
    setSelectedOption: Dispatch<SetStateAction<number>>;
};

function ExamBox(props: Props) {
    const {
        next,
        userId,
        examId,
        counter,
        question,
        jobTitle,
        showHelp,
        enableNext,
        setShowHelp,
        totalQuestions,
        selectedOption,
        isLastQuestion,
        questionOptions,
        currentQuestion,
        onSelectFromHelp,
        setSelectedOption,
        isFetchingQuestions,
    } = props;

    useProctoring(userId, examId, currentQuestion, 'multipleChoiceExam');

    const showHideHelp = (e: MouseEvent<SVGSVGElement>) => {
        e.stopPropagation();
        setShowHelp(prev => !prev);
    };

    return (
        <div className={styles.wrapper} onClick={() => setShowHelp(false)}>
            <div className={styles.content} data-time-out={counter === 0}>
                <div className={styles.header}>
                    <span className={styles.question_count}>
                        {`${currentQuestion} / ${totalQuestions}`}
                    </span>
                    <span className={styles.job_title}>{jobTitle}</span>
                    <div className={styles.help}>
                        <HelpIcon onClick={showHideHelp} />
                        {showHelp && <div className={styles.help_list}>
                            {questionHelp.map(i => <span onClick={onSelectFromHelp}>{i}</span>)}
                        </div>}
                    </div>
                </div>
                <span className={styles.question}>
                    {currentQuestion} - {question.split('```')[0].split(/(\`.*?\`)/g).map(i => {
                        if (i.startsWith('`')) {
                            return <code>{i.slice(1, i.length - 1)}</code>
                        } else {
                            return <span>{i}</span>
                        }
                    })}
                </span>
                {question.includes('```') && <div className={styles.codeBlock}>
                    <CodeBlock
                        text={question.split('```')[1]}
                        language={'python'}
                        showLineNumbers={true}
                        theme={dracula}
                    />
                </div>}
                <span className={styles.question}>
                    {question.split('```')[2]?.split(/(\`.*?\`)/g).map(i => {
                        if (i.startsWith('`')) {
                            return <code className={styles.code}>{i.slice(1, i.length - 1)}</code>
                        } else {
                            return <span>{i}</span>
                        }
                    })}
                </span>
                <div className={styles.options}>
                    {questionOptions.map((q, idx) =>
                        <RadioButton
                            text={q}
                            disabled={counter === 0}
                            checked={selectedOption === idx}
                            setChecked={() => setSelectedOption(idx)}
                            radioClassName={counter === 0 ? styles.timeOutRadio : ''}
                        />)}
                </div>
            </div>
            <Button
                onClick={next}
                className={styles.CTA}
                loading={isFetchingQuestions}
                type={(isLastQuestion || counter === 0) ? 'Error' : 'Primary'}
                disabled={enableNext ? false : (counter !== 0 && selectedOption === -1)}
                text={isLastQuestion ? 'End exam' : counter === 0 ? 'Time out' : 'Next question'}
            />
        </div>
    )
};

export default ExamBox;
